import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TwitterIcon,
} from "lucide-react";

export const socialLinks = [
  { icon: LinkedinIcon, alt: "Linkedin", href: "https://www.linkedin.com/company/fydoin/" },
  { icon: InstagramIcon, alt: "Instagram", href: "https://www.instagram.com/fydoin" },
  { icon: TwitterIcon, alt: "Twitter", href: "https://x.com/fydoin" },
  { icon: FacebookIcon, alt: "Facebook", href: "https://www.facebook.com/fydoin" },
];